/*
 * SVH: legfeljebb 80 db/variáns a kosárban, csak nem követett készletű és
 * előrendelhető (inventory_policy = continue) variánsoknál.
 *
 * A Kalles meglévő mennyiség-validációjára épül (az input `max` attribútuma,
 * amit a Liquid már 80-ra állít); a minified Kalles fájlokhoz nem nyúl.
 *  1. Variánsváltáskor a Kalles 9999-et ír a `max`-ba ezeknél a variánsoknál -> 80.
 *  2. 80 fölé lépéskor saját magyar üzenet a Kalles készlet-üzenete helyett.
 *  3. /cart/add: a kosárban már lévő mennyiséget is beszámítja. Ha a végösszeg
 *     80 fölé menne, a kérés el sem indul; a Kalles a szokásos hibaüzenetet mutatja.
 * Követett + "ne add el, ha elfogyott" variánsoknál semmi nem változik.
 */
(function () {
  'use strict';

  var LIMIT = 80;
  var KALLES_UNCAPPED = 9999; // a Kalles ezt írja max-nak nem követett / continue variánsnál
  var CAP_ATTR = 'data-svh-qty-cap';
  var MSG_MAX = 'Ebből a termékből legfeljebb ' + LIMIT + ' darab rendelhető.';

  function msgInCart(inCart) {
    var left = Math.max(LIMIT - inCart, 0);
    return 'Ebből a termékből legfeljebb ' + LIMIT + ' darab rendelhető. A kosárban már ' + inCart +
      ' darab van, így ' + (left > 0 ? 'legfeljebb még ' + left + ' darab adható hozzá.' : 'több nem adható hozzá.');
  }

  function notify(msg) {
    if (window.T4SThemeSP && typeof T4SThemeSP.Notices === 'function') T4SThemeSP.Notices(msg);
    else window.alert(msg);
  }

  /* 1. max attribútum: a Kalles 9999-ét 80-ra vágjuk */
  function capInput(el) {
    var max = parseInt(el.getAttribute('max'), 10);
    if (max >= KALLES_UNCAPPED) {
      el.setAttribute(CAP_ATTR, '');
      el.setAttribute('max', LIMIT);
    } else if (max !== LIMIT) {
      el.removeAttribute(CAP_ATTR); // követett variánsra váltott: a Kalles készlet-max marad
    }
  }

  function capWithin(node) {
    if (node.nodeType !== 1) return;
    if (node.matches('[data-quantity-value]')) capInput(node);
    var inputs = node.querySelectorAll('[data-quantity-value]');
    for (var i = 0; i < inputs.length; i++) capInput(inputs[i]);
  }

  new MutationObserver(function (records) {
    records.forEach(function (r) {
      if (r.type === 'attributes') {
        if (r.target.matches('[data-quantity-value]')) capInput(r.target);
      } else {
        r.addedNodes.forEach(capWithin);
      }
    });
  }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['max'] });
  capWithin(document.documentElement);

  /* 2. Saját üzenet 80 fölött (capture fázis: a Kalles kezelője előtt fut) */
  window.addEventListener('change', function (e) {
    var el = e.target;
    if (!el.hasAttribute || !el.hasAttribute(CAP_ATTR)) return;
    if (parseInt(el.value, 10) > LIMIT) {
      el.value = LIMIT; // a Kalles ezután a szokásos módon 80-nal dolgozik tovább
      notify(MSG_MAX);
    }
  }, true);

  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-increase-qty]');
    if (!btn) return;
    var wrap = btn.closest('[data-quantity-wrapper]');
    var el = wrap && wrap.querySelector('[data-quantity-value]');
    if (!el || !el.hasAttribute(CAP_ATTR) || parseFloat(el.value) < LIMIT) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    notify(MSG_MAX);
  }, true);

  /* 3. /cart/add: kosárban lévő mennyiség beszámítása */
  var nativeFetch = window.fetch;
  if (!nativeFetch) return;

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js)?$/.test(new URL(url, location.href).pathname); } catch (err) { return false; }
  }

  // [{id, qty}] a kérés törzséből (FormData, JSON vagy urlencoded)
  function requestedLines(body) {
    var lines = [];
    function push(id, qty) { if (id) lines.push({ id: String(id), qty: parseInt(qty, 10) || 1 }); }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var ids = body.getAll('items[][id]'), qtys = body.getAll('items[][quantity]');
      if (ids.length) ids.forEach(function (id, i) { push(id, qtys[i]); });
      else push(body.get('id'), body.get('quantity'));
    } else if (typeof body === 'string' || body instanceof URLSearchParams) {
      var json = null;
      if (typeof body === 'string') { try { json = JSON.parse(body); } catch (err) { /* nem JSON */ } }
      if (json) (json.items || [json]).forEach(function (it) { push(it.id, it.quantity); });
      else { var p = new URLSearchParams(body); push(p.get('id'), p.get('quantity')); }
    }
    return lines;
  }

  // nem követett / continue variánsok: a Liquid a termékűrlap mennyiség-mezőjére írja
  function isCapped(id) {
    return !!document.querySelector('[data-svh-cap-ids~="' + id + '"]');
  }

  function reject(msg) {
    var body = JSON.stringify({ status: 422, message: 'Cart Error', description: msg });
    return Promise.resolve(new Response(body, { status: 422, headers: { 'Content-Type': 'application/json' } }));
  }

  window.fetch = function (input, init) {
    var self = this || window, args = arguments;
    var url = typeof input === 'string' ? input : (input && input.url) || String(input);
    var method = ((init && init.method) || 'GET').toUpperCase();
    if (method !== 'POST' || !init || !init.body || !isCartAdd(url)) return nativeFetch.apply(self, args);

    var wanted = {};
    requestedLines(init.body).forEach(function (l) {
      if (isCapped(l.id)) wanted[l.id] = (wanted[l.id] || 0) + l.qty;
    });
    if (!Object.keys(wanted).length) return nativeFetch.apply(self, args);

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return nativeFetch.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var id in wanted) {
          var inCart = 0;
          (cart.items || []).forEach(function (it) { if (String(it.variant_id) === id) inCart += it.quantity; });
          if (inCart + wanted[id] > LIMIT) return reject(inCart > 0 ? msgInCart(inCart) : MSG_MAX);
        }
        return nativeFetch.apply(self, args);
      }, function () {
        return nativeFetch.apply(self, args); // ha a kosár nem olvasható, nem blokkolunk
      });
  };
})();
